<template>
    <router-view/>
</template>
<script src="./App.js"></script>
